import a from "react";
import { FormControlLabel as t, Radio as u, RadioGroup as i } from "@mui/material";
const o = (e) => /* @__PURE__ */ a.createElement(
  t,
  {
    value: e.value,
    control: /* @__PURE__ */ a.createElement(
      u,
      {
        id: e.id,
        disableFocusRipple: !0,
        onChange: (n) => {
          e.onChange && e.onChange(n);
        },
        onBlur: e.onBlur,
        checked: e.checked && e.checked,
        inputProps: { "aria-label": e.ariaLabel }
      }
    ),
    disabled: e.disabled,
    label: e.label ? e.label : ""
  }
), r = (e) => /* @__PURE__ */ a.createElement(
  i,
  {
    id: e.id,
    row: e.direction === "row",
    name: e.name,
    value: e.value,
    onChange: e.onChange,
    onBlur: e.onBlur
  },
  e.buttons.map((n, l) => /* @__PURE__ */ a.createElement(o, { key: l, ...n }))
);
export {
  r as R
};
